import React, {useState} from 'react'
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Button, Col, Container, Row} from 'reactstrap';
import NoSearchResult from "../../components/Common/NoSearchResult";
import PermissionGroupAccordion from "./components/PermissionGroupAccordion";
import ModalPermissionGroup from "./components/ModalPermissionGroup";
import ModalPermission from "./components/ModalPermission";
import {useQuery} from "@tanstack/react-query";
import {PermissionsService} from "../../services/permissions.service";
import {IPermissionGroupPagination} from "../../store/permissions/types";
import {Navigate} from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";

interface ModalState {
    isModalOpen: boolean;
    id: number | null;
    selectedGroupId?: number | null;
}

const Permissions = () => {
    document.title = "Permissions | Dashboard";

    const {hasPermission} = usePermissions();
    if (!hasPermission("view-permissions")) return <Navigate to="/no-access"/>

    const [groupModal, setGroupModal] = useState<ModalState>({isModalOpen: false, id: null});
    const [permissionModal, setPermissionModal] = useState<ModalState>({isModalOpen: false, id: null});

    const permissionsGroupsWithUngrouped = (resp: IPermissionGroupPagination): IPermissionGroupPagination => {
        if (resp.ungrouped.length === 0 || !resp.ungrouped) return resp

        const groups = [...resp.data, {id: -1, name: "Ungrouped", icon: "no-entry", permissions: [...resp.ungrouped]}]
        return {...resp, data: groups};
    }

    const {data: permissionsGroups, isLoading, isError} = useQuery({
        queryKey: ["keyPermissionsGroups"],
        queryFn: () => PermissionsService.getGroupsAll(),
        select: permissionsGroupsWithUngrouped
    });

    const handleAddGroup = () => {
        setGroupModal({isModalOpen: true, id: null});
    }

    const handleUpdateGroup = (groupId: number) => {
        setGroupModal({isModalOpen: true, id: groupId});
    }

    const handleGroupModalClose = () => {
        setGroupModal({isModalOpen: false, id: null});
    }

    const handleAddPermission = (selectedGroupId: number) => {
        setPermissionModal({isModalOpen: true, id: null, selectedGroupId: selectedGroupId});
    }

    const handleUpdatePermission = (permissionId: number) => {
        setPermissionModal({isModalOpen: true, id: permissionId});
    }

    const handlePermissionModalClose = () => {
        setPermissionModal({isModalOpen: false, id: null});
    }

    return (
        <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="Dashboard" breadcrumbItem="Permissions"/>

                <Row className="align-items-center">
                    <Col md={12}>
                        <div className="d-flex align-items-center justify-content-end">
                            {// hasPermission("create-permissions") &&
                                <Button className="d-flex align-items-center gap-1" color="light"
                                        onClick={handleAddGroup}>
                                    <i className="bx bx-plus me-1"></i> Add Group
                                </Button>
                            }
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        {!isLoading && permissionsGroups && permissionsGroups?.data.length
                            && <PermissionGroupAccordion groups={permissionsGroups.data}
                                                         onAddPermission={handleAddPermission}
                                                         onUpdateGroud={handleUpdateGroup}
                                                         onUpdatePermission={handleUpdatePermission}/>}

                        {!isLoading && permissionsGroups?.data.length === 0 && (<NoSearchResult/>)}
                        {isLoading && (<NoSearchResult text="Loading..."/>)}
                        {isError && (<NoSearchResult/>)}
                    </Col>
                </Row>

                {groupModal.isModalOpen &&
                    <ModalPermissionGroup isOpen={groupModal.isModalOpen}
                                          groupId={groupModal.id}
                                          onClose={handleGroupModalClose}/>}

                {permissionModal.isModalOpen &&
                    <ModalPermission isOpen={permissionModal.isModalOpen}
                                     permissionId={permissionModal.id}
                                     selectedGroupId={permissionModal.selectedGroupId}
                                     onClose={handlePermissionModalClose}/>}
            </Container>
        </div>
    )
}

export default Permissions;